<template>
  <div class="write-course">
    <el-form class="course-edit" :model="courseDetail" :rules="rules" ref="upCourse">
      <el-form-item label="课程标题" prop="title">
        <el-input v-model="courseDetail.title" placeholder="请输入课程名称"></el-input>
      </el-form-item>
      <el-form-item label="课程视频上传">
        <el-upload
          class="upload-demo"
          :action="action"
          accept=".mp4,.avi,.MP4, .AVI"
          :http-request="httpRequest"
          :on-success="uploadSuccess"
          :file-list="videoList"
          :before-upload="beforeUploadVideo"
          drag
        >
          <div class="upload-inner">
            <span class="ue-btn ue-btn-filling">点击或拖拽上传课程视频</span>
            <div slot="tip" class="el-upload__tip">视频大小不超过2GB，支持MP4、AVI</div>
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <div style="text-align:left">课程说明</div>
        <div id="course-editor" class="course-editor"></div>
      </el-form-item>
    </el-form>
    <div class="btns-box">
      <diV class="btns">
        <el-button class="ue-btn ue-btn-light" plain @click="saveCourse" type="danger">暂存</el-button>
        <div class="ue-btn ue-btn-light" @click="previewCourse">预览</div>
        <div class="ue-btn ue-btn-filling" @click="toPostSet()">下一步</div>
      </diV>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import CourseSet from "@/components/course/courseSet";
import videomixin from "@/assets/js/mixins/vod";
import Quill from "quill";
import "quill/dist/quill.snow.css";
export default {
  name: "write-post",
  mixins: [videomixin],
  data() {
    return {
      rules: {
        title: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
        ],
      },
      courseDetail: {
        obID: '',
        title: '',
        videoFileId: '',
        videoName: '',
        post: '',
        articleType: '1', // 表示课程
        totalTime: '',
        text: ''
      },
      videoList:[],
      tcVod: null, // 播放插件
      action: 'https://ueclub.kingdee.com',
      quillOptions: {
        theme: 'snow',
        placeholder: "请输入正文...",
        modules: {
          toolbar: [[{ list: "ordered" }, { list: "bullet" }]]
        }
      },
      quill: null,
      show: true
    };
  },
  computed: {
    ...mapGetters('post', ['post'])
  },
  watch: {
    post(newVal) {
      if(!newVal) return
      const post = newVal.post
      this.courseDetail = {
        obID: post._id,
        title: post.title,
        videoFileId: post.videoFileId,
        videoName: post.videoName,
        post: post.post,
        articleType: '1', // 表示课程
        totalTime: post.totalTime,
        text: post.text
      }
      if(this.post.post && this.post.post.post) {
        this.quill.clipboard.dangerouslyPasteHTML(this.post.post.post)
      }
      this.videoList = [{name: post.videoName, url: ''}]
    }
  },
  components: {},
  methods: {
    ...mapActions('post', ['queryUpload', 'uploadFile', 'savePost', 'getPost']),
    async httpRequest(config) {
      const file = config.file;
      this.getVideoTotalTime(file);
      let uploader = this.tcVod.upload({
        videoFile: file
      });
      uploader.on("video_progress", function(info) {
        info.percent = (info.loaded / info.total) * 100;
        config.onProgress(info, file);
      });
      uploader.on("video_upload", info => {
      });
      let doneResult = await uploader.done();
      await this.getCreate(doneResult);
      config.onSuccess(doneResult, file);
      this.courseDetail.videoName = file.name
    },
    uploadSuccess(res) {
      if (res) {
        this.courseDetail.videoFileId = res.fileId;
      }
    },
    beforeUploadVideo (file) {
      if (['video/mp4','video/avi','video/mov'].indexOf(file.type) == -1) {
        this.$message.error('请上传正确的视频格式');
        return false;
      }
    },
    async createArticle() {
      let ele = document.querySelector(
        "#course-editor"
      ).children[0]
      this.courseDetail.post = ele.innerHTML;
      this.courseDetail.text = ele.innerText.replace(/[ ]/, '').substring(0, Math.min(100, ele.innerText.length))
      this.courseDetail.obID = await this.savePost(this.courseDetail);
    },
    saveCourse() { // 保存按钮
      this.courseDetail.status = 3 // 文章状态暂存
      this.submitForm('upCourse').then(() => {
       this.createArticle()
        this.$message({
          message: '课程成功存为草稿',
          type: 'success'
        })
      }).catch(e => {
        console.log(e)
      })
    },
    async previewCourse() {
      this.courseDetail.status = 3 // 暂存
      await this.createArticle()
      window.open(`/courseDetail/${this.courseDetail.obID}`)
    },
    async toPostSet() {
       this.courseDetail.status = 2 // 待审核
       this.submitForm('upCourse').then(async () => {
         await this.saveCourse()
         if(this.$route.params.id === 'new'){
          CourseSet.open(this.courseDetail)
        } else {
          CourseSet.open({
            'tags': this.post.post.tags,
            'category2': this.post.post.category2,
            'permiss': this.post.post.permiss,
            'coverPhoto': this.post.post.coverPhoto,
            'sourceFile': this.post.post.sourceFile,
            ...this.courseDetail})
        }
      }).catch(e => {
        console.log(e)
      })
    },
    submitForm(formName) {
      return new Promise((res, rej) => {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            res(valid)
          } else {
            rej(new Error())
          }
       });
      })
    },
    getVideoTotalTime(file) {
      const checktimevideo = document.getElementById("getVideoTotalTime");
      if (checktimevideo) {
        document.body.removeChild(checktimevideo);
      }
      const video = document.createElement("video");
      const url = URL.createObjectURL(file);
      video.src = url;
      video.id = "getVideoTotalTime";
      video.style.display = "none";
      document.body.appendChild(video);
      video.addEventListener("canplaythrough", e => {
        this.courseDetail.totalTime = e.target.duration;
      });
    },
  },
  mounted() {
    this.tcVod = new TcVod.default({
      getSignature: this.getSignature
    });
    this.quill = new Quill("#course-editor", this.quillOptions);
  },
  created () {
    if(this.$route.params.id && this.$route.params.id !== 'new') {
      this.getPost(this.$route.params.id)
    }
  }
};
</script>
<style lang="scss" scoped>
.write-course {
  width: 886px;
  margin: auto;
  padding-bottom: 100px;
  > .course-edit {
    > .course-title {
      div {
        text-align: left;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        margin: 0 0 14px;
      }
      input {
        width: 886px;
        height: 42px;
        font-size: 14px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 19px;
        padding-left: 15px;
        display: block;
        outline: none;
      }
    }
    > .up-course {
      p {
        text-align: left;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        margin: 49px 0 14px 0;
      }
      .upload-demo {
        .upload-inner {
          height: 141px;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: space-evenly;
        }
      }
      > .upcourse-button {
        > .up-button-content {
          width: 886px;
          height: 141px;
          background: rgba(248, 248, 248, 1);
          .el-button {
            width: 216px;
            height: 38px;
            background: rgba(231, 0, 18, 1);
            border-radius: 19px;
            border: 0px solid rgba(223, 224, 226, 1);
            padding: 5px 14px 6px 14px;
            margin: 32px 0 13px 0;
            > span {
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: rgba(255, 255, 255, 1);
              line-height: 19px;
            }
          }
          .el-upload__tip {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(153, 153, 153, 1);
            line-height: 16px;
          }
        }
      }
    }
    > .course-explain {
      p {
        text-align: left;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        margin: 49px 0 14px 0;
      }
      > .course-editor-editorll {
        width: 100%;
        > .quill-editor {
          width: 886px;
          > .ql-container {
            width: 100%;
            height: 323px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.write-course {
  .ql-toolbar.ql-snow .ql-formats {
    margin-right: 0;
    float: left;
  }
  .ql-toolbar.ql-snow {
    padding-left: 10px;
  }
  .ql-editor {
    min-height: 285px;
  }
  .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
      height: 141px;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }
}
</style>



